import React from "react";
import PropTypes from 'prop-types';
import Tooltip from 'react-tooltip-lite';
import CONST from "../../config/CONST";

const InfoTooltip = (props) => {

    const {
        id,
        content
    } = props;

    const getContent = (c) => {
        return (
            <div dangerouslySetInnerHTML={{__html: c}} />
        );
    }

    return (
        <span className={`${CONST.CSS_NAMESPACE}InfoTooltip`}>
            <div>
                <Tooltip
                    content={getContent(content)}
                    defaultStyles={false}
                    hoverDelay={10}
                    mouseOutDelay={200}
                    arrow={true}
                    zIndex={999999999}
                    tipContentClassName={`${CONST.CSS_NAMESPACE}tipcontent`}
                    direction="down"
                    //forceDirection={true}
                >
                    <svg version="1.1" id={id} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                         viewBox="0 0 20.3 20.3">
                        <path fill="#FFFFFF" d="M20.2,10.2c0,5.5-4.5,10-10,10s-10-4.5-10-10c0-5.5,4.5-10,10-10C15.7,0.1,20.2,4.6,20.2,10.2"/>
                        <path fill="#000000" d="M8.6,5.5c0-0.9,0.7-1.5,1.5-1.5c0.9,0,1.5,0.7,1.5,1.5C11.7,6.3,11,7,10.2,7C9.3,7,8.6,6.3,8.6,5.5z
                             M8.9,16.4h2.5V9.3H8.9V16.4z"/>
                    </svg>
                </Tooltip>
            </div>
        </span>
    );
};

InfoTooltip.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string
};

export default InfoTooltip;
